export default {
    beforeMount(el) {
        const screenWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if(screenWidth > 991) {
            el.src = el.srcset
        }
    }
}
